import { render, staticRenderFns } from "./finish1.vue?vue&type=template&id=0952dd1a&"
import script from "./finish1.vue?vue&type=script&lang=js&"
export * from "./finish1.vue?vue&type=script&lang=js&"
import style0 from "./finish1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports